import { render, staticRenderFns } from "./PosEditPromotion.vue?vue&type=template&id=50f31606&scoped=true&"
import script from "./PosEditPromotion.vue?vue&type=script&lang=js&"
export * from "./PosEditPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f31606",
  null
  
)

export default component.exports